import { Figure } from 'codegen/schema'
import { urlForImage } from 'lib/sanity'

export const getThumbnailSrc = (thumbnailImage?: Figure): string | undefined => {
  if (!thumbnailImage) return

  return urlForImage(thumbnailImage).width(1200).height(627).fit('crop').url() || undefined
}
